import Box from "@/common/components/Box";
import MaintenanceWorkflowSolicitations from "./components/MaintenanceWorkflowSolicitations";
import ResumeItem from "@/common/components/ResumeItem";
import { MaintenanceWorkflowData } from "@/features/maintenanceWorkflow/types/maintenanceWorkflows.type";

interface MaintenanceDescriptionProps {
  workflow: MaintenanceWorkflowData | undefined;
}

const MaintenanceDescription = ({ workflow }: MaintenanceDescriptionProps) => {
  return (
    <Box className="p-4 flex flex-col gap-4 max-h-[calc(100vh-12rem)] overflow-auto">
      <div className="flex flex-col gap-2">
        <p>
          Solicitações de manutenção
        </p>

        <ResumeItem
          label="Descrição geral do processo"
          value={workflow?.observations || '--'}
          isLoading={!workflow}
          labelClassName="text-xs"
          valueClassName="text-sm"
        />
      </div>

      <MaintenanceWorkflowSolicitations />
    </Box>
  );
}

export default MaintenanceDescription;
